module.exports = __webpack_public_path__ + "static/img/25.5e93913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/25.png
// module id = +fTA
// module chunks = 0